"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _reactSlick = _interopRequireDefault(require("react-slick"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledCarousel = require("./StyledCarousel");
var _excluded = ["forwardedRef", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Carousel = /*#__PURE__*/function (_Component) {
  function Carousel() {
    (0, _classCallCheck2.default)(this, Carousel);
    return _callSuper(this, Carousel, arguments);
  }
  (0, _inherits2.default)(Carousel, _Component);
  return (0, _createClass2.default)(Carousel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        forwardedRef = _this$props.forwardedRef,
        children = _this$props.children,
        rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/_react.default.createElement(_StyledCarousel.CarouselContainer, {
          theme: theme
        }, /*#__PURE__*/_react.default.createElement(_reactSlick.default, (0, _extends2.default)({}, rest, {
          ref: forwardedRef
        }), children));
      });
    }
  }]);
}(_react.Component);
Carousel.propTypes = {
  /**
   * Enable tabbing and arrow key navigation
   */
  accessibility: _propTypes.default.bool,
  /**
   * Adjust the slide's height automatically
   */
  adaptiveHeight: _propTypes.default.bool,
  /**
   * Index change callback. `index => ...`
   */
  afterChange: _propTypes.default.func,
  /**
   *  Custom dots templates. Works same as customPaging
   */
  appendDots: _propTypes.default.func,
  /**
   *  Delay between each auto scroll (in milliseconds)
   */
  autoplaySpeed: _propTypes.default.number,
  /**
   *  Index change callback. `(oldIndex, newIndex) => ...`
   */
  beforeChange: _propTypes.default.func,
  /**
   *  Center current slide
   */
  centerMode: _propTypes.default.bool,
  /**
   *  CSS class for inner slider div
   */
  className: _propTypes.default.string,
  /**
   *  Custom paging templates. Example below.
   */
  customPaging: _propTypes.default.func,
  /**
   *  CSS class for dots
   */
  dotsClass: _propTypes.default.string,
  dots: _propTypes.default.bool,
  /**
   *  Enable scrollable via dragging on desktop
   */
  draggable: _propTypes.default.bool,
  easing: _propTypes.default.string,
  fade: _propTypes.default.bool,
  /**
   *  Go to slide on click
   */
  focusOnSelect: _propTypes.default.bool,
  /**
   *  Infinitely wrap around contents
   */
  infinite: _propTypes.default.bool,
  /**
   *  Index of first slide
   */
  initialSlide: _propTypes.default.number,
  /**
   *  Load images or render components on demand or progressively
   */
  lazyLoad: _propTypes.default.bool,
  /**
   *  UNSAFE_componentWillMount callback. `() => void`
   */
  onInit: _propTypes.default.func,
  /**
   *  Callback after slides load lazily `slidesLoaded => {...}`
   */
  onLazyLoad: _propTypes.default.func,
  /**
   *  componentDidUpdate callback. `() => void`
   */
  onReInit: _propTypes.default.func,
  /**
   *  Callback after slide changes by swiping
   */
  onSwipe: _propTypes.default.func,
  /**
   *  Prevents autoplay while hovering on dots
   */
  pauseOnDotsHover: _propTypes.default.bool,
  /**
   *  Prevents autoplay while focused on slides
   */
  pauseOnFocus: _propTypes.default.bool,
  /**
   *  Prevents autoplay while hovering on track
   */
  pauseOnHover: _propTypes.default.bool,
  /**
   *  Customize based on breakpoints (see the example for better understanding)
   */
  responsive: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.object)]),
  /**
   *  number of rows per slide in the slider, (enables grid mode)
   */
  rows: _propTypes.default.number,
  /**
   *  Reverses the slide order
   */
  rtl: _propTypes.default.bool,
  /**
   *  Slide container type
   */
  slide: _propTypes.default.string,
  /**
   *  number of slides to display in grid mode, this is useful with rows option
   */
  slidesPerRow: _propTypes.default.number,
  /**
   *  How many slides to scroll at once
   */
  slidesToScroll: _propTypes.default.number,
  /**
   *  How many slides to show in one frame
   */
  slidesToShow: _propTypes.default.number,
  /**
   * Animation speed in milliseconds
   */
  speed: _propTypes.default.number,
  /**
   * Enable drag/swipe irrespective of `slidesToScroll`
   */
  swipeToSlide: _propTypes.default.bool,
  /**
   * Enable/disable swiping to change slides
   */
  swipe: _propTypes.default.bool,
  touchMove: _propTypes.default.bool,
  touchThreshold: _propTypes.default.number,
  /**
   * Enable/Disable CSS Transitions
   */
  useCSS: _propTypes.default.bool,
  /**
   * Enable/Disable CSS transforms
   */
  useTransform: _propTypes.default.bool,
  variableWidth: _propTypes.default.bool,
  vertical: _propTypes.default.bool,
  autoPlay: _propTypes.default.bool,
  arrows: _propTypes.default.bool,
  slideToShow: _propTypes.default.number,
  slideToScroll: _propTypes.default.number,
  nextArrow: _propTypes.default.object,
  prevArrow: _propTypes.default.object
};
Carousel.defaultProps = {
  speed: 500,
  slideToShow: 1,
  slideToScroll: 1,
  accessibility: true,
  adaptiveHeight: false,
  arrows: true,
  autoplaySpeed: 3000,
  autoPlay: false,
  centerMode: false,
  centerPadding: '50px',
  dotsClass: 'slick-dots',
  dots: true,
  draggable: true,
  easing: 'linear',
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  rows: 1,
  slide: 'div',
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  swipe: true,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  nextArrow: /*#__PURE__*/_react.default.createElement(NextArrow, null),
  prevArrow: /*#__PURE__*/_react.default.createElement(PrevArrow, null),
  customPaging: function customPaging(i) {
    return /*#__PURE__*/_react.default.createElement("button", null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "round"
    }));
  }
};
function NextArrow(props) {
  var className = props.className,
    style = props.style,
    onClick = props.onClick;
  return /*#__PURE__*/_react.default.createElement("button", {
    className: className,
    style: style,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "angle-right"
  }));
}
function PrevArrow(props) {
  var className = props.className,
    style = props.style,
    onClick = props.onClick;
  return /*#__PURE__*/_react.default.createElement("button", {
    className: className,
    style: style,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "angle-left"
  }));
}

// export default Carousel;
var _default = exports.default = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement(Carousel, (0, _extends2.default)({}, props, {
    forwardedRef: ref
  }));
});